/**
 * @fileoverview GET handler for the "/companies/:company_id/mobile_app_linking_configs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdMobileAppLinkingConfigs } from "./constants";
import type {
  GetCompaniesCompanyIdMobileAppLinkingConfigsParams,
  GetCompaniesCompanyIdMobileAppLinkingConfigsResult,
} from "./types";
import { isGetCompaniesCompanyIdMobileAppLinkingConfigsResult } from "./validators";

export const getCompaniesCompanyIdMobileAppLinkingConfigs = reactQueryFetcherAdapter(
  companiesCompanyIdMobileAppLinkingConfigs,
  (
    signal: AbortSignal,
    companyId: string,
    params: GetCompaniesCompanyIdMobileAppLinkingConfigsParams
  ): Promise<GetCompaniesCompanyIdMobileAppLinkingConfigsResult> => {
    const { q = "", status = "all", start = 0, limit = 10 } = params ?? {};
    return fetch(
      `/companies/${companyId}/mobile_app_linking_configs`,
      "GET",
      {
        q,
        status,
        start,
        limit,
      },
      { signal }
    );
  },
  isGetCompaniesCompanyIdMobileAppLinkingConfigsResult
);
